import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import Sidebar from './Sidebar.js';
import Admin from './Admin.js';
import Tagger from './Tagger.js';
import Reviewer from './Reviewer.js';
import Manager from './Manager.js';
import RequireAuth from './RequiredAuth.js';
import CreateTask from './CreateTask.js';
import CreateProfile from './CreateProfile.js';
import AssignToReviewer from './AssignToReviewer.js';
import Reports from './Reports.js';
import CreateProject from './CreateProject.js';
import NewProject from './project/CreateProject.js';
import AllProjects from './project/index.js';
import CreateProfileManager from './CreateProfileManager.js';
import ProfileDetailsManager from './ProfileDetailsManager.js';
import Forgotpassword from './Forgotpassword.js';
import HistoricalRecords from './HistoricalRecords.js';
import BulkUpload from './BulkUpload.js';
import Filter from './Filter.js';
import ProjectTask from './project/ProjectTask.js';
import TaggerData from './TaggerData.js';
import SignIn from './SignIn.js';
import useAuth from '../hooks/useAuth';
import HistoricalRecordData from './HistoricalRecordData.js';
import ReviewerData from './ReviewerData.js';
import Request from './Request.js';

const Dashboard = () => {
  const { auth } = useAuth();
  
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/signin"
          element={
            auth?.token ? (
              <Navigate to="/admin" replace />
            ) : (
              <SignIn />
            )
          }
        />

        {/* RequireAuth now wraps Sidebar */}
        <Route path="/" element={<RequireAuth />}>
          <Route element={<Sidebar />}>
            {/* Corrected:  Index route for /  and path for /admin */}
            <Route index element={<Navigate to="/projects" replace />} />
            <Route path="/projects" element={<AllProjects />} />
            <Route path="/filter" element={<Filter />} />
            <Route path="/tagger" element={<Tagger />} />
            <Route path="/tagger/tasks" element={<TaggerData />} />
            <Route path="/reviewer" element={<Reviewer />} />
            <Route path="/reviewer/tasks" element={<ReviewerData />} />
            <Route path="/manager" element={<Manager />} />
            <Route path="/createtask" element={<CreateTask />} />
            <Route path="/createprofile" element={<CreateProfile />} />
            <Route path="/assigntoreviewer" element={<AssignToReviewer />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/bulkupload" element={<BulkUpload />} />
            <Route path="/createproject" element={<CreateProject />} />
            <Route path="/newproject" element={<NewProject />} />
            <Route path="/projects/tasks" element={<ProjectTask />} />
            <Route path="/createprofilemanager" element={<CreateProfileManager />} />
            <Route path="/profiledetailsmanager" element={<ProfileDetailsManager />} />
            <Route path="/historicalrecords" element={<HistoricalRecords />} />
            <Route path="/historicalrecord/tasks" element={<HistoricalRecordData />} />
            <Route path="/requests" element={<Request />} />
          </Route>
        </Route>

        <Route path="/resetpassword/:pid/:pemail" element={<Forgotpassword />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Dashboard;
